import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
export const containerSizeMap = {
    small: '24px',
    medium: '48px',
    large: '96px',
};
export const labelSizeMap = {
    small: '10px',
    medium: '16px',
    large: '24px',
};
const getContainerSize = (size) => {
    return `
    height: ${containerSizeMap[size]};
    width: ${containerSizeMap[size]};
  `;
};
const getLabelSize = (size) => {
    return `
    font-size: ${labelSizeMap[size]};
  `;
};
export const StyledContainer = styled.span.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-xp65xs" }) `
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: var(${(props) => props.theme.colors.ui.secondary});
  border-radius: 100%;
  color: var(${(props) => props.theme.colors.ui.inverted});
  ${(props) => getContainerSize(props.size)}
  ${injectSpacing('margin')}
`;
export const StyledImage = styled.img.withConfig({ displayName: "auir-611444a-StyledImage", componentId: "auir-611444a-1oj8myv" }) `
  position: absolute;
  display: block;
  width: 100%;
`;
export const StyledLabel = styled.span.withConfig({ displayName: "auir-611444a-StyledLabel", componentId: "auir-611444a-45j56s" }) `
  font-weight: 550;
  font-family: var(${(props) => props.theme.fontFamily});
  line-height: 0;

  ${injectOSXFontSmoothing(true)}
  ${(props) => getLabelSize(props.size)}
`;
//# sourceMappingURL=Avatar.styles.mjs.mjs.map